import { type FC } from "react";

import type { FlowCustomComponentProps } from "@/shared/constants/flowTypes";

import { AttorneyCta } from "./AttorneyCta";

export const WillCopyInfoScreen: FC<FlowCustomComponentProps> = () => {
  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-1">
        <p className="font-sans text-xl font-semibold leading-[30px]">
          Courts need special proof to use a copy
        </p>
        <p className="text-sm text-secondary tracking-[-0.28px]">
          New York courts prefer the original signed paper. To use a copy, state law requires
          custom written statements (affidavits) proving the original wasn't intentionally
          destroyed or lost.
        </p>
      </div>

      <div className="flex flex-col rounded-lg border border-primary overflow-clip">
        <div className="flex flex-col gap-2 bg-white border-b border-primary p-6">
          <p className="text-sm font-semibold">Double-check for the original paper</p>
          <p className="text-sm text-secondary tracking-[-0.28px]">
            Look through home files and safes, or reach out to the lawyer who wrote the will.
            Attorneys often keep the original for safekeeping.
          </p>
        </div>
        <div className="flex flex-col gap-2 bg-white p-6">
          <p className="text-sm font-semibold">Custom legal statements are required</p>
          <p className="text-sm text-secondary tracking-[-0.28px]">
            Because standard court filings are built for original wills, your case requires custom
            written statements (affidavits). We will help you gather the right details to include
            in your final filing packet.
          </p>
        </div>
      </div>

      <AttorneyCta
        title="Questions? Talk to an attorney"
        body="Because filing with a copy requires custom legal affidavits, let's get an attorney on your team. Included in your plan, an attorney will review your file and guide you through the next steps."
      />
    </div>
  );
};
